/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import { Formik, FormikProps } from 'formik'
import { getNewSL, mapToDictSysLogs } from '../helpers'
import type { StepProps } from '../models'
import {
  AlertSettings as AlertSettingsForm,
  AlertSettingsFormActions
} from './components/form.alert.settings'
import {
  getAlertSettingsFormConfig,
  AlertSettingsValues
} from './configurations'
import type {
  SyslogServerInfo,
  AlertSeverityEnum
} from '@src/endpoints/services/commonHdr.service'

export interface AlertSettingsState {
  infoPanelHidden: boolean
  severity: AlertSeverityEnum
}

const AlertSettings: React.FC<StepProps> = (props: StepProps) => {
  const { notificationSettings = {}, severity, updateUser } = props
  const { syslog = [] } = notificationSettings

  const initialValues: AlertSettingsValues = {
    severity,
    slackChannelUrl: Array.from(notificationSettings?.slack_url || []),
    notification_email_id: Array.from(notificationSettings?.email || []),
    syslog_servers: getSysLogs(syslog)
  }

  const alertActions: AlertSettingsFormActions = {
    updateUser
  }

  const [state] = React.useState<AlertSettingsState>({
    infoPanelHidden: true,
    severity
  })

  function getSysLogs(syslog_servers: SyslogServerInfo[]) {
    const hasSysLogs = syslog_servers.length > 0
    return hasSysLogs ? mapToDictSysLogs(syslog_servers) : getNewSL()
  }

  // function showInfoPanel() {
  //   setState(prev => ({
  //     ...prev,
  //     infoPanelHidden: true // not showing info panel for now
  //   }))
  // }
  //
  // function hideInfoPanel() {
  //   setState(prev => ({
  //     ...prev,
  //     infoPanelHidden: true
  //   }))
  // }

  return (
    <Formik
      {...getAlertSettingsFormConfig({
        initialValues,
        state,
        stepProps: props
      })}
    >
      {(formikProps: FormikProps<AlertSettingsValues>) => (
        <AlertSettingsForm
          formikProps={formikProps}
          state={state}
          stepProps={props}
          alertActions={alertActions}
        />
      )}
    </Formik>
  )
}

export default AlertSettings
